<template>
  <div class="ibox content-box">
    <div class="ibox-title" v-if="title">
      <h5>{{title}}</h5>
      <div class="ibox-tools">
        <slot name="tools" />
      </div>
    </div>
    <div :class="['ibox-content', !title ? 'no-title' : '']">
      <slot name="content" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.content-box .ibox-title {
  border-top-left-radius: $layout-border-radius;
  border-top-right-radius: $layout-border-radius;
}
.content-box .ibox-content {
  border-bottom-left-radius: $layout-border-radius;
  border-bottom-right-radius: $layout-border-radius;
}
.content-box .ibox-content.no-title {
  border-top-left-radius: $layout-border-radius;
  border-top-right-radius: $layout-border-radius;
}
</style>

<script>
export default {
  name: "ContentBox",
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>